import { render, staticRenderFns } from "./m-form-cash-register.vue?vue&type=template&id=6def92cf&scoped=true&lang=pug&"
import script from "./m-form-cash-register.vue?vue&type=script&lang=js&"
export * from "./m-form-cash-register.vue?vue&type=script&lang=js&"
import style0 from "./m-form-cash-register.vue?vue&type=style&index=0&id=6def92cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def92cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VRow})
